import { render, staticRenderFns } from "./ManageUsersHeader.vue?vue&type=template&id=7fefd3ca&"
import script from "./ManageUsersHeader.vue?vue&type=script&lang=js&"
export * from "./ManageUsersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports